<div class="container-fluid mb-4">
  <div class="row mb-3">
    <div class="col">
      <h5 class="lead-title">Lead {{ isEntity ? 'Entity' : 'Lawyer' }} - {{ lead.fullname }}</h5>
    </div>
    <div class="col text-end">
      <button *ngIf="!editMode" class="btn btn-primary btn-sm" (click)="toggleEditMode()">
        <i class="bi bi-pencil-square"></i> Edit Details
      </button>
      <div *ngIf="editMode" class="btn-group">
        <button class="btn btn-success btn-sm" (click)="saveChanges()">
          <i class="bi bi-check-lg"></i> Save
        </button>
        <button class="btn btn-secondary btn-sm" (click)="toggleEditMode()">
          <i class="bi bi-x-lg"></i> Cancel
        </button>
      </div>
    </div>
  </div>

  <form [formGroup]="leadForm">
    <div class="row">
      <!-- Left Column -->
      <div class="col-md-6">
        <div class="mb-3">
          <label class="form-label fw-bold">Firm Name <span class="text-danger">*</span></label>
          <div *ngIf="!editMode" class="form-control-static">{{ lead.fullname }}</div>
          <input *ngIf="editMode" type="text" class="form-control" formControlName="fullname">
          <div *ngIf="editMode && leadForm.get('fullname')?.invalid && leadForm.get('fullname')?.touched" class="text-danger small">
            Name is required
          </div>
        </div>

        <div class="mb-3">
          <label class="form-label fw-bold">Firm Email <span class="text-danger">*</span></label>
          <div *ngIf="!editMode" class="form-control-static">{{ lead.email }}</div>
          <input *ngIf="editMode" type="email" class="form-control" formControlName="email">
          <div *ngIf="editMode && leadForm.get('email')?.invalid && leadForm.get('email')?.touched" class="text-danger small">
            Valid email is required
          </div>
        </div>

        <div class="mb-3">
          <label class="form-label fw-bold">Registration Number (TIN) <span class="text-danger">*</span></label>
          <div *ngIf="!editMode" class="form-control-static">{{ lead.tin }}</div>
          <input *ngIf="editMode" type="text" class="form-control" formControlName="tin">
          <div *ngIf="editMode && leadForm.get('tin')?.invalid && leadForm.get('tin')?.touched" class="text-danger small">
            Registration number is required
          </div>
        </div>

        <div class="mb-3">
          <label class="form-label fw-bold">Contact Person</label>
          <div *ngIf="!editMode" class="form-control-static">{{ lead.additional_category }}</div>
          <input *ngIf="editMode" type="text" class="form-control" formControlName="additional_category">
        </div>

        <div class="mb-3">
          <label class="form-label fw-bold">Address</label>
          <div *ngIf="!editMode" class="form-control-static">
            {{ lead.address?.house_flat_no }} {{ lead.address?.street }}, 
            {{ lead.address?.city_town }}, {{ lead.address?.state }}, 
            {{ lead.address?.country }} - {{ lead.address?.zipcode }}
          </div>
          <div *ngIf="editMode" formGroupName="address">
            <div class="row mb-2">
              <div class="col-md-6">
                <label class="form-label small">Address Type</label>
                <select class="form-select form-select-sm" formControlName="address_type">
                  <option value="Home">Home</option>
                  <option value="Office">Office</option>
                  <option value="Other">Other</option>
                </select>
              </div>
              <div class="col-md-6">
                <label class="form-label small">House/Flat No</label>
                <input type="text" class="form-control form-control-sm" formControlName="house_flat_no">
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-md-6">
                <label class="form-label small">Street</label>
                <input type="text" class="form-control form-control-sm" formControlName="street">
              </div>
              <div class="col-md-6">
                <label class="form-label small">Landmark</label>
                <input type="text" class="form-control form-control-sm" formControlName="landmark">
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-md-6">
                <label class="form-label small">City/Town</label>
                <input type="text" class="form-control form-control-sm" formControlName="city_town">
              </div>
              <div class="col-md-6">
                <label class="form-label small">State</label>
                <input type="text" class="form-control form-control-sm" formControlName="state">
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-md-6">
                <label class="form-label small">Country</label>
                <select class="form-select form-select-sm" formControlName="country">
                  <option *ngFor="let country of countries" [value]="country">{{ country }}</option>
                </select>
              </div>
              <div class="col-md-6">
                <label class="form-label small">Zipcode</label>
                <input type="text" class="form-control form-control-sm" formControlName="zipcode">
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Right Column -->
      <div class="col-md-6">
        <div class="mb-3">
          <label class="form-label fw-bold">Area(s) Of Specialization <span class="text-danger">*</span></label>
          <div *ngIf="!editMode" class="form-control-static">{{ lead.subcategory?.join(', ') }}</div>
          <select *ngIf="editMode" class="form-select" formControlName="subcategory">
            <option *ngFor="let spec of specializations" [value]="spec">{{ spec }}</option>
          </select>
          <div *ngIf="editMode && leadForm.get('subcategory')?.invalid && leadForm.get('subcategory')?.touched" class="text-danger small">
            Specialization is required
          </div>
        </div>

        <div class="mb-3">
          <label class="form-label fw-bold">Designation</label>
          <div *ngIf="!editMode" class="form-control-static">{{ lead.designation }}</div>
          <input *ngIf="editMode" type="text" class="form-control" formControlName="designation">
        </div>

        <div class="mb-3">
          <label class="form-label fw-bold">Number Of Lawyers</label>
          <div *ngIf="!editMode" class="form-control-static">{{ lead.no_of_lawyers }}</div>
          <input *ngIf="editMode" type="number" class="form-control" formControlName="no_of_lawyers">
        </div>

        <div class="mb-3">
          <label class="form-label fw-bold">Contact Number</label>
          <div *ngIf="!editMode" class="form-control-static">{{ lead.contact_phone }}</div>
          <input *ngIf="editMode" type="text" class="form-control" formControlName="contact_phone">
          <div *ngIf="editMode && leadForm.get('contact_phone')?.invalid && leadForm.get('contact_phone')?.touched" class="text-danger small">
            Enter a valid 10-digit number
          </div>
        </div>

        <div class="mb-3">
          <label class="form-label fw-bold">Status</label>
          <div *ngIf="!editMode" class="form-control-static">{{ lead.status }}</div>
          <select *ngIf="editMode" class="form-select" formControlName="status">
            <option value="New">New</option>
            <option value="Contacted">Contacted</option>
            <option value="Qualified">Qualified</option>
            <option value="Converted">Converted</option>
            <option value="Lost">Lost</option>
          </select>
        </div>

        <div class="mb-3">
          <label class="form-label fw-bold">Additional Details</label>
          <div *ngIf="!editMode" class="form-control-static">{{ lead.notes }}</div>
          <textarea *ngIf="editMode" class="form-control" rows="3" formControlName="notes"></textarea>
        </div>
      </div>
    </div>
  </form>
</div>